export const linkIDs = {
  AutomationHubTools: 'AutomationHubTools',
  CreateSingleLabels: 'CREATE_SINGLE_LABELS',
  CustomStoreSetup: 'CUSTOM_STORE_SETUP',
  TrackShipments: 'TRACK_SHIPMENTS',
  BrandedReturns: 'BRANDED_RETURNS',
  WalletRegistrationTerms: 'WALLET_REGISTRATION_TERMS',
  QuickstartAccountSetup: 'QUICKSTART_ACCOUNT_SETUP',
  BrandedSMS: 'BRANDED_SMS',
  Shipstation2021Terms: 'SHIPSTATION_2021_TERMS',
  Shipstation2021Privacy: 'SHIPSTATION_2021_PRIVACY',
  ShipStationConnectHelp: 'SHIPSTATION_CONNECT_HELP',
  ShipStationConnectPathfinder: 'SHIPSTATION_CONNECT_PATHFINDER',
  ShipstationUniversity: 'ShipstationUniversity',
  ShipsuranceKB: 'ShipsuranceKB',
  StampsPrivacyPolicy: 'StampsPrivacyPolicy',
  StampsTermsAndConditions: 'StampsTermsAndConditions',
  UpsPromotionalRatesAgreement: 'UpsPromotionalRatesAgreement',
  UpsSupplementalTerms: 'UpsSupplementalTerms',
  UpsTechnologyAgreement: 'UpsTechnologyAgreement',
  UpsProhibitedItems: 'UpsProhibitedItems',
  UpsDangerousGoods: 'UpsDangerousGoods',
  UpsPaperlessInvoice: 'UpsPaperlessInvoice',
  OneBalanceTerms: 'OneBalanceTerms',
  MessageLimitations: 'MessageLimitations',
  BillingEngineUkTerms: 'BillingEngineUkTerms',
  ViewStockCounts: 'ViewStockCounts',
  CanparOneBalanceKb: 'CanparOneBalanceKb',
  CanadaPostOneBalanceKb: 'CanadaPostOneBalanceKb',
  UberWalletedTerms: 'UberWalletedTerms',
  MercadoLibreRestrictions: 'MercadoLibreRestrictions',
  ServiceMappingsKb: 'ServiceMappingsKb',
  InsightsPages: 'InsightsPages',
  CheckoutRatesConfiguration: 'CheckoutRatesConfiguration',
  CheckoutRatesDimensionalConfiguration: 'CheckoutRatesDimensionalConfiguration',
  WalletRegistrationHelpLinks: 'WalletRegistrationHelpLinks',
  XCoverKB: 'XCoverKB',
  PaymentAndSubscriptionSettings: 'paymentAndSubscriptionSettings',
  PurolatorWalletTerms: 'PurolatorWalletTerms',
  EbayEmailTemplates: 'EbayEmailTemplates',
  AllocateDeallocateStock: 'AllocateDeallocateStock',
  OrderRouting: 'OrderRouting',
  ProductAliases: 'ProductAliases',
  MarkOrdersShipped: 'MarkOrdersShipped',
  UsingQuickship: 'UsingQuickship',
  ImportCsvOrders: 'ImportCsvOrders',
  ImportCsvProducts: 'ImportCsvProducts',
  ImportCsvInventory: 'ImportCsvInventory',
  ImportCsvDangerousGoods: 'ImportCsvDangerousGoods',
  ImportCsvPurchaseOrder: 'ImportCsvPurchaseOrder',
  ImportCsvSuppliers: 'ImportCsvSuppliers',
  ShipperHq: 'ShipperHq',
  EDesk: 'EDesk',
  ConstantContact: 'ConstantContact',
  AmazonMarketplace: 'AmazonMarketplace',
  InternationalDutiesBilling: 'InternationalDutiesBilling',
  SubScriptionPlan: 'SubScriptionPlan',
  SendRatesStoreCheckout: 'SendRatesStoreCheckout',
  ThirdPartyLogisticsProvider: 'ThirdPartyLogisticsProvider',
  DropshipManager: 'DropshipManager',
  MoveToNewLayout: 'MoveToNewLayout',
  GlobalPostWalletTerms: 'GlobalPostWalletTerms',
  GlobalPostHelpArticle: 'GlobalPostHelpArticle',
  SendleWalletTerms: 'SendleWalletTerms',
  SendleDangerousGoods: 'SendleDangerousGoods',
  FulfillmentProviders: 'FulfillmentProviders',
  StoreErrorHelp: 'StoreErrorHelp',
  CubiscanDimensioners: 'CubiscanDimensioners',
  ParcelGuardKB: 'ParcelGuardKB',
  ShipsuranceTerms: 'ShipsuranceTerms',
  XCoverTerms: 'XCoverTerms',
  XCoverInformation: 'XCoverInformation',
  ParcelGuardTerms: 'ParcelGuardTerms',
  MexicanPackageContentDescription: 'MexicanPackageContentDescription',
  CarrierSharing: 'CarrierSharing',
  PackingSlipSharing: 'PackingSlipSharing',
  FileParcelGuardClaim: 'FileParcelGuardClaim',
  FileXCoverClaim: 'FileXCoverClaim',
  CarrierIntegrations: 'CarrierIntegrations',
  ReconfigureEtsy: 'ReconfigureEtsy',
  ReconfigureStore: 'ReconfigureStore',
  ReconfigureEbay: 'ReconfigureEbay',
  ShipStationStatus: 'ShipStationStatus',
  FedExWalletTerms: 'FedExWalletTerms',
  DHLExpressCAWAlletTerms: 'DHLExpressCAWalletTerms',
  TaxIdentifierRequirements: 'TaxIdentifierRequirements',
  StampsDHLExpressTerms: 'StampsDHLExpressTerms',
  YodelWalletTerms: 'YodelWalletTerms',
  EVRiWalletTerms: 'EVRiWalletTerms',
  ParcelforceWalletTerms: 'ParcelforceWalletTerms',
  DpdWalletTerms: 'DpdWalletTerms',
  ODBCOverview: 'ODBCOverview',
  AutoSplitOverview: 'AutoSplitOverview',
  ProductBundlesOverview: 'ProductBundlesOverview',
  ShippingStrategiesOverview: 'ShippingStrategiesOverview',
  DHLEcommerceTerms: 'DHLEcommerceTerms',
  EditStoreSettings: 'EditStoreSettings',
  DHLEcommerceDDPTerms: 'DHLEcommerceDDPTerms',
  DelegateOrdersFulfillmentProviders: 'DelegateOrdersFulfillmentProviders',
  ReturnRabbit: 'ReturnRabbit',
  SendleCAWalletTerms: 'SendleCAWalletTerms',
  SendleCAWalletDangerousGoods: 'SendleCAWalletDangerousGoods',
  ShipStationCarriers: 'ShipStationCarriers',
  ConnectBYOA: 'ConnectBYOA',
  SplitShip: 'SplitShip',
  CustomerSupport: 'CustomerSupport',
  SenderEmails: 'SenderEmails',
  CommonLabelRateErrors: 'CommonLabelRateErrors',
  InventorySync: 'InventorySync',
  InventorySyncTargetsFAQ: 'InventorySyncTargetsFAQ',
  FinaleInventory: 'FinaleInventory',
  CIN7Inventory: 'CIN7Inventory',
  SkuVaultInventory: 'SkuVaultInventory',
  EcomDashInventory: 'EcomDashInventory',
  FishbowlInventory: 'FishbowlInventory',
  ZenventoryInventory: 'ZenventoryInventory',
  CreatePrintYourFirstLabel: 'CreatePrintYourFirstLabel',
  CompareRates: 'CompareRates',
  WhatIsBranding: 'WhatIsBranding',
  CreateCustomEmailTemplates: 'CreateCustomEmailTemplates',
  ImportOrdersFromAStore: 'ImportOrdersFromAStore',
  CreateAutomationRules: 'CreateAutomationRules',
  AutomationRuleExamples: 'AutomationRuleExamples',
  BrandedTrackingPage: 'BrandedTrackingPage',
  ReturnLabels: 'ReturnLabels',
  AddInsuranceToShipments: 'AddInsuranceToShipments',
  AddressValidation: 'AddressValidation',
  CreateCustomPackage: 'CreateCustomPackage',
  ShipInternationally: 'ShipInternationally',
  InternationalSettings: 'InternationalSettings',
  CustomizePackingSlips: 'CustomizePackingSlips',
  TagOrders: 'TagOrders',
  OutgoingReturns: 'OutgoingReturns',
  BrandedReturnsPortal: 'BrandedReturnsPortal',
  ManualReturns: 'ManualReturns',
  SelectLabelLayout: 'SelectLabelLayout',
  CreateShippingPresets: 'CreateShippingPresets',
  BarcodePresets: 'BarcodePresets',
  PrintingWithConnect: 'PrintingWithConnect',
  ShopifyInventory: 'ShopifyInventory',
  InsightsReports: 'InsightsReports',
  CommunityIdeas: 'CommunityIdeas',
  GoogleShippingData: 'GoogleShippingData',
  InventoryInShipstation: 'InventoryInShipstation',
  ShippingStrategiesHelp: 'ShippingStrategiesHelp',
  WindsorFrameworkDetails: 'WindsorFrameworkDetails',
  BrtItWalletTerms: 'BrtItWalletTerms',
  CorreosExpressWalletTerms: 'CorreosExpressWalletTerms',
  RateShopperHelp: 'RateShopperHelp',
  ShipstationApiDocs: 'ShipstationApiDocs',
  ShipstationV2ApiDocs: 'ShipstationV2ApiDocs',
  AdaptiveMfaInfo: 'AdaptiveMfaInfo',
  AustraliaPostMyPostBusinessWalletTerms: 'AustraliaPostMyPostBusinessWalletTerms',
  AustraliaPostMyPostBusinessWalletEcommercePartnerResellerTerms: 'AustraliaPostMyPostBusinessWalletEcommercePartnerResellerTerms',
  WhyIsTaxIDRequired: 'WhyIsTaxIDRequired',
  AramexAUWalletConditionsOfCarriage: 'AramexAUWalletConditionsOfCarriage',
  RoyalMailClickAndDropWalletTerms: 'RoyalMailClickAndDropWalletTerms',
  DHLExpressMyDHLWalletTerms: 'DHLExpressMyDHLWalletTerms',
  AmazonShippingWalletTerms: 'AmazonShippingWalletTerms',
  RefundAssist: 'RefundAssist',
  EnhancedReturns: 'EnhancedReturns',
  AmazonShippingPickup: 'AmazonShippingPickup',
  ParcelforceRoyalMailClickAndDropWalletTerms: 'ParcelforceRoyalMailClickAndDropWalletTerms',
  ProductSyncLearnMore: 'ProductSyncLearnMore',
  ShopifyMetafieldsLearnMore: 'ShopifyMetafieldsLearnMore',
  UserRoles: 'UserRoles',
  CustomsUpdates: 'CustomsUpdates',
};

export const links = {
  AutomationHubTools: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025870192-Automation-Basics',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025870192-Automation-Basics',
      },
    },
  },

  CREATE_SINGLE_LABELS: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026157651',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026157651',
      },
      AU: {
        en: 'https://help.shipstation.com/hc/en-au/articles/360026157651',
      },
      CA: {
        en: 'https://help.shipstation.com/hc/en-ca/articles/360026157651',
      },
      FR: {
        fr: 'https://help.shipstation.com/hc/fr-fr/articles/360026157651',
      },
      GB: {
        en: 'https://help.shipstation.com/hc/en-gb/articles/360026157651',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360026157651',
      },
    },
  },

  CUSTOM_STORE_SETUP: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025856192',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025856192',
        es: 'https://help.shipstation.com/hc/es-us/articles/360025856192',
      },
    },
  },

  TRACK_SHIPMENTS: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026157731',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026157731',
      },
      CA: {
        en: 'https://help.shipstation.com/hc/en-ca/articles/360026157731',
      },
      GB: {
        en: 'https://help.shipstation.com/hc/en-gb/articles/360026157731',
      },
      AU: {
        en: 'https://help.shipstation.com/hc/en-au/articles/360026157731',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360026157731',
      },
    },
  },

  BRANDED_RETURNS: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026158371',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026158371',
      },
      CA: {
        en: 'https://help.shipstation.com/hc/en-ca/articles/360026158371',
      },
      GB: {
        en: 'https://help.shipstation.com/hc/en-gb/articles/360026158371',
      },
      AU: {
        en: 'https://help.shipstation.com/hc/en-au/articles/360026158371',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360026158371',
      },
    },
  },

  QUICKSTART_ACCOUNT_SETUP: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026151511',
    },
  },

  BRANDED_SMS: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360058589271',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360058589271',
      },
      CA: {
        en: 'https://help.shipstation.com/hc/en-ca/articles/360058589271',
      },
    },
  },

  MessageLimitations: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/4405471313435',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/4405471313435',
      },
      CA: {
        en: 'https://help.shipstation.com/hc/en-ca/articles/4405471313435',
      },
    },
  },

  SHIPSTATION_2021_TERMS: {
    ShipStation: {
      default: 'https://www.shipstation.com/terms-of-service/',
      CA: {
        en: 'https://www.shipstation.com/ca/terms-of-service/',
        fr: 'https://shipstation.ca/ca-fr/terms-of-service/',
        'fr-CA': 'https://shipstation.ca/ca-fr/terms-of-service/',
        default: 'https://www.shipstation.com/ca/terms-of-service/',
      },
      FR: {
        fr: 'https://www.shipstation.com/terms-of-service-france/',
        default: 'https://www.shipstation.com/terms-of-service-france/',
      },
    },
  },

  SHIPSTATION_2021_PRIVACY: {
    ShipStation: {
      default: 'https://www.shipstation.com/privacy-policy/',
      CA: {
        en: 'https://www.shipstation.com/ca/privacy-policy/',
        fr: 'https://shipstation.ca/ca-fr/privacy-policy/',
        'fr-CA': 'https://shipstation.ca/ca-fr/privacy-policy/',
        default: 'https://www.shipstation.com/ca/privacy-policy/',
      },
      FR: {
        fr: 'https://www.shipstation.com/privacy-policy-france/',
        default: 'https://www.shipstation.com/privacy-policy-france/',
      },
    },
  },

  SHIPSTATION_CONNECT_HELP: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026157851',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026157851',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360026157851',
      },
    },
  },

  SHIPSTATION_CONNECT_PATHFINDER: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/19621238678171',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/19621238678171',
      },
    },
  },

  ShipstationUniversity: {
    ShipStation: {
      US: {
        default: 'https://learning.shipstation.com',
      },
      GB: {
        default: 'https://learning.shipstation.com',
      },
      default: 'https://learning.shipstation.com',
    },
  },

  ViewStockCounts: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360055114232',
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360055114232',
      },
    },
  },

  StampsPrivacyPolicy: {
    ShipStation: {
      default: 'https://www.stamps.com/privacy-policy',
    },
  },

  StampsTermsAndConditions: {
    ShipStation: {
      default: 'https://www.stamps.com/conditions/',
    },
  },

  UpsPromotionalRatesAgreement: {
    ShipStation: {
      default: 'https://www.ups.com/assets/resources/media/en_US/CQF_US.pdf',
      '2.0': 'https://www.ups.com/assets/resources/media/en_US/UPS_DAP_TC.pdf',
      '3.0': 'https://www.ups.com/assets/resources/webcontent/en_US/ups_dap_supplemental_tc.pdf',
      US: {
        default: 'https://www.ups.com/assets/resources/media/en_US/CQF_US.pdf',
        '2.0': 'https://www.ups.com/assets/resources/media/en_US/UPS_DAP_TC.pdf',
        '3.0': 'https://www.ups.com/assets/resources/webcontent/en_US/ups_dap_supplemental_tc.pdf',
      },
      CA: {
        default: 'https://www.ups.com/assets/resources/media/en_CA/D5Q_CA.pdf?promoCode=D5Q5DRWBV',
        en: 'https://www.ups.com/assets/resources/media/en_CA/D5Q_CA.pdf?promoCode=D5Q5DRWBV',
        fr: 'https://www.ups.com/assets/resources/media/fr_CA/D5Q_CA.pdf?promoCode=D5Q5DRWBV',
        'fr-CA': 'https://www.ups.com/assets/resources/media/fr_CA/D5Q_CA.pdf?promoCode=D5Q5DRWBV',
      },
    },
  },

  UpsSupplementalTerms: {
    ShipStation: {
      default: 'https://www.ups.com/us/en/support/shipping-support/legal-terms-conditions.page',
      US: {
        default: 'https://www.ups.com/us/en/support/shipping-support/legal-terms-conditions.page',
        en: 'https://www.ups.com/us/en/support/shipping-support/legal-terms-conditions.page',
      },
      CA: {
        default: 'https://www.ups.com/ca/en/support/shipping-support/legal-terms-conditions.page',
        en: 'https://www.ups.com/ca/en/support/shipping-support/legal-terms-conditions.page',
        fr: 'https://www.ups.com/ca/fr/support/shipping-support/legal-terms-conditions.page?loc=fr_CA',
        'fr-CA': 'https://www.ups.com/ca/fr/support/shipping-support/legal-terms-conditions.page?loc=fr_CA',
      },
      GB: {
        default: 'https://www.ups.com/gb/en/support/shipping-support/legal-terms-conditions.page',
        en: 'https://www.ups.com/gb/en/support/shipping-support/legal-terms-conditions.page',
      },
    },
  },

  UpsPaperlessInvoice: {
    ShipStation: {
      default: 'https://www.ups.com/assets/resources/media/en_CA/Acknowledgment_for_UPS_Paperless_Invoice.pdf',
      US: {
        default: 'https://www.ups.com/assets/resources/media/Acknowledgment_for_UPS_Paperless_Invoice.pdf',
        en: 'https://www.ups.com/assets/resources/media/Acknowledgment_for_UPS_Paperless_Invoice.pdf',
      },
      CA: {
        default: 'https://www.ups.com/assets/resources/media/en_CA/Acknowledgment_for_UPS_Paperless_Invoice.pdf',
        en: 'https://www.ups.com/assets/resources/media/en_CA/Acknowledgment_for_UPS_Paperless_Invoice.pdf',
        fr: 'https://www.ups.com/assets/resources/media/fr_CA/Acknowledgment_for_UPS_Paperless_Invoice.pdf',
        'fr-CA': 'https://www.ups.com/assets/resources/media/fr_CA/Acknowledgment_for_UPS_Paperless_Invoice.pdf',
      },
      GB: {
        default: 'https://www.ups.com/assets/resources/webcontent/en_GB/DAP-paperless-invoice-terms-conditions.pdf',
        en: 'https://www.ups.com/assets/resources/webcontent/en_GB/DAP-paperless-invoice-terms-conditions.pdf',
      },
    },
  },

  UpsDangerousGoods: {
    ShipStation: {
      default: 'https://www.ups.com/us/en/support/shipping-support/shipping-special-care-regulated-items/prohibited-items',
      US: {
        default: 'https://www.ups.com/us/en/support/shipping-support/shipping-special-care-regulated-items/prohibited-items',
        en: 'https://www.ups.com/us/en/support/shipping-support/shipping-special-care-regulated-items/prohibited-items',
      },
      CA: {
        default: 'https://www.ups.com/ca/en/help-center/packaging-and-supplies/special-care-shipments/international-dangerous-goods.page',
        en: 'https://www.ups.com/ca/en/help-center/packaging-and-supplies/special-care-shipments/international-dangerous-goods.page',
        fr: 'https://www.ups.com/ca/fr/help-center/packaging-and-supplies/special-care-shipments/international-dangerous-goods.page?loc=fr_CA',
        'fr-CA':
          'https://www.ups.com/ca/fr/help-center/packaging-and-supplies/special-care-shipments/international-dangerous-goods.page?loc=fr_CA',
      },
      GB: {
        default: 'https://www.ups.com/gb/en/support/shipping-support/shipping-special-care-regulated-items.page',
        en: 'https://www.ups.com/gb/en/support/shipping-support/shipping-special-care-regulated-items.page',
      },
    },
  },

  UpsTechnologyAgreement: {
    ShipStation: {
      default: 'https://www.ups.com/assets/resources/media/en_US/UTA.pdf',
      US: {
        default: 'https://www.ups.com/assets/resources/media/en_US/UTA.pdf',
        en: 'https://www.ups.com/assets/resources/media/en_US/UTA.pdf',
      },
      CA: {
        default: 'https://www.ups.com/assets/resources/media/en_CA/UTA.pdf',
        en: 'https://www.ups.com/assets/resources/media/en_CA/UTA.pdf',
        fr: 'https://www.ups.com/assets/resources/media/fr_CA/UTA.pdf',
        'fr-CA': 'https://www.ups.com/assets/resources/media/fr_CA/UTA.pdf',
      },
      GB: {
        default: 'https://www.ups.com/gb/en/support/shipping-support/legal-terms-conditions.page',
        en: 'https://www.ups.com/gb/en/support/shipping-support/legal-terms-conditions.page',
      },
    },
  },

  UpsProhibitedItems: {
    ShipStation: {
      default: 'https://www.ups.com/us/en/support/shipping-support/shipping-special-care-regulated-items/prohibited-items.page',
      US: {
        default: 'https://www.ups.com/us/en/support/shipping-support/shipping-special-care-regulated-items/prohibited-items.page',
        en: 'https://www.ups.com/us/en/support/shipping-support/shipping-special-care-regulated-items/prohibited-items.page',
      },
      CA: {
        default: 'https://www.ups.com/ca/en/support/shipping-support/shipping-special-care-regulated-items/prohibited-items.page',
        en: 'https://www.ups.com/ca/en/support/shipping-support/shipping-special-care-regulated-items/prohibited-items.page',
        fr: 'https://www.ups.com/ca/fr/support/shipping-support/shipping-special-care-regulated-items/prohibited-items.page',
        'fr-CA': 'https://www.ups.com/ca/fr/support/shipping-support/shipping-special-care-regulated-items/prohibited-items.page',
      },
      GB: {
        default: 'https://www.ups.com/gb/en/support/shipping-support/shipping-special-care-regulated-items/prohibited-items.page',
        en: 'https://www.ups.com/gb/en/support/shipping-support/shipping-special-care-regulated-items/prohibited-items.page',
      },
    },
  },

  OneBalanceTerms: {
    ShipStation: {
      CA: {
        en: 'https://shipstation-cdn-us-east-1-813448775391.s3.amazonaws.com/docs/ShipStation_Canada_Terms_of_Service_EN_FINAL_2021-01-25.pdf',
        fr: 'https://shipstation-cdn-us-east-1-813448775391.s3.amazonaws.com/docs/ShipStation_Canada_Terms_of_Service_FR_FINAL_2021-01-25.pdf',
        'fr-CA':
          'https://shipstation-cdn-us-east-1-813448775391.s3.amazonaws.com/docs/ShipStation_Canada_Terms_of_Service_FR_FINAL_2021-01-25.pdf',
      },
      default:
        'https://shipstation-cdn-us-east-1-813448775391.s3.amazonaws.com/docs/ShipStation_Canada_Terms_of_Service_EN_FINAL_2021-01-25.pdf',
    },
  },

  WALLET_REGISTRATION_TERMS: {
    ShipStation: {
      CA: {
        en: 'https://shipstation-cdn-us-east-1-813448775391.s3.amazonaws.com/docs/ShipStation_Canada_Terms_of_Service_EN_FINAL_2021-01-25.pdf',
        fr: 'https://shipstation-cdn-us-east-1-813448775391.s3.amazonaws.com/docs/ShipStation_Canada_Terms_of_Service_FR_FINAL_2021-01-25.pdf',
        'fr-CA':
          'https://shipstation-cdn-us-east-1-813448775391.s3.amazonaws.com/docs/ShipStation_Canada_Terms_of_Service_FR_FINAL_2021-01-25.pdf',
      },
      default:
        'https://shipstation-cdn-us-east-1-813448775391.s3.amazonaws.com/docs/ShipStation_Canada_Terms_of_Service_EN_FINAL_2021-01-25.pdf',
    },
  },

  BillingEngineUkTerms: {
    ShipStation: {
      default: 'https://www.shipstation.com/terms-service-united-kingdom/',
    },
  },

  CanparOneBalanceKb: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/28656576023707',
    },
  },

  CanadaPostOneBalanceKb: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/28656571464731',
    },
  },

  UberWalletedTerms: {
    ShipStation: {
      default: 'https://www.uber.com/legal/en/document/?country=united-states&lang=en&name=general-terms-of-use',
    },
  },

  MercadoLibreRestrictions: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/4406997350939',
    },
  },

  ServiceMappingsKb: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025870232',
      CA: {
        en: 'https://help.shipstation.com/hc/en-ca/articles/360025870232',
        fr: 'https://help.shipstation.com/hc/fr-fr/articles/360025870232',
        'fr-CA': 'https://help.shipstation.com/hc/fr-fr/articles/360025870232',
        default: 'https://help.shipstation.com/hc/en-us/articles/360025870232',
      },
      FR: {
        fr: 'https://help.shipstation.com/hc/fr-fr/articles/360025870232',
        default: 'https://help.shipstation.com/hc/en-us/articles/360025870232',
      },
      GB: {
        en: 'https://help.shipstation.com/hc/en-gb/articles/360025870232',
        default: 'https://help.shipstation.com/hc/en-us/articles/360025870232',
      },
      AU: {
        en: 'https://help.shipstation.com/hc/en-au/articles/360025870232',
        default: 'https://help.shipstation.com/hc/en-us/articles/360025870232',
      },
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025870232',
        default: 'https://help.shipstation.com/hc/en-us/articles/360025870232',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360025870232',
        default: 'https://help.shipstation.com/hc/en-us/articles/360025870232',
      },
    },
  },

  InsightsPages: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026158151',
      CA: {
        'fr-CA': 'https://help.shipstation.com/hc/fr-ca/articles/360026158151',
        default: 'https://help.shipstation.com/hc/en-us/articles/360026158151',
      },
      FR: {
        en: 'hhttps://help.shipstation.com/hc/en-us/articles/360026158151',
        default: 'https://help.shipstation.com/hc/fr-fr/articles/360026158151',
      },
      DE: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026158151',
        default: 'https://help.shipstation.com/hc/de/articles/360026158151',
      },
      GB: {
        default: 'https://help.shipstation.com/hc/en-gb/articles/360026158151',
      },
      AU: {
        default: 'https://help.shipstation.com/hc/en-au/articles/360026158151',
      },
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026158151',
        default: 'https://help.shipstation.com/hc/en-us/articles/360026158151',
      },
    },
  },

  CheckoutRatesConfiguration: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/4410971840923',
      AU: {
        default: 'https://help.shipstation.com/hc/en-au/articles/4410971840923',
      },
    },
  },

  CheckoutRatesDimensionalConfiguration: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/25719436122139',
      AU: {
        default: 'https://help.shipstation.com/hc/en-au/articles/25719436122139',
      },
    },
  },

  WalletRegistrationHelpLinks: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026142091',
      CA: {
        default: 'https://help.shipstation.com/hc/en-ca/articles/360026142091',
      },
      GB: {
        default: 'https://help.shipstation.com/hc/en-gb/articles/360026142091',
      },
      AU: {
        default: 'https://help.shipstation.com/hc/en-au/articles/360026142091',
      },
      US: {
        default: 'https://help.shipstation.com/hc/en-us/articles/360026142091',
      },
    },
  },

  ShipsuranceKB: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026142391-Shipsurance',
    },
  },

  XCoverKB: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/28656549816091',
      AU: {
        default: 'https://help.shipstation.com/hc/en-au/articles/28656549816091',
      },
    },
  },

  ParcelGuardKB: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/14888782725915',
    },
  },

  paymentAndSubscriptionSettings: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026158291',
      CA: {
        default: 'https://help.shipstation.com/hc/en-ca/articles/360026158291',
      },
      GB: {
        default: 'https://help.shipstation.com/hc/en-gb/articles/360026158291',
      },
      AU: {
        default: 'https://help.shipstation.com/hc/en-au/articles/360026158291',
      },
      US: {
        default: 'https://help.shipstation.com/hc/en-us/articles/360026158291',
      },
      DE: {
        default: 'https://help.shipstation.com/hc/de/articles/360026158291',
      },
    },
  },

  PurolatorWalletTerms: {
    ShipStation: {
      default: 'https://www.purolator.com/en/terms-and-conditions-service',
      CA: {
        'fr-CA': 'https://www.purolator.com/fr/modalites-et-conditions-de-service',
        default: 'https://www.purolator.com/en/terms-and-conditions-service',
      },
    },
  },

  EbayEmailTemplates: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/4401796782747',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/4401796782747',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/4401796782747',
      },
    },
  },

  AllocateDeallocateStock: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360035706192',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360035706192',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360035706192',
      },
    },
  },

  OrderRouting: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/19061848728347',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/19061848728347',
      },
    },
  },

  ProductAliases: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025870352',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025870352',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360025870352',
      },
    },
  },

  MarkOrdersShipped: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026157691',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026157691',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360026157691',
      },
    },
  },

  UsingQuickship: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025869752',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025869752',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360025869752',
      },
    },
  },

  ImportCsvOrders: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360036323571',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360036323571',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360036323571',
      },
      FR: {
        default: 'https://help.shipstation.com/hc/fr-fr/articles/360036323571',
      },
    },
  },

  ShipperHq: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360058971792',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360058971792',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360058971792',
      },
    },
  },

  ImportCsvProducts: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026158091',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026158091',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360026158091',
      },
      FR: {
        default: 'https://help.shipstation.com/hc/fr-fr/articles/360026158091',
      },
    },
  },

  ImportCsvDangerousGoods: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/34911859685275',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/34911859685275',
      },
    },
  },

  ImportCsvInventory: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026158551',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026158551',
      },
    },
  },

  ImportCsvPurchaseOrder: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/38888006702619',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/38888006702619',
      },
    },
  },
  ImportCsvSuppliers: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/38888006702619',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/38888006702619',
      },
    },
  },
  EDesk: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025856352',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025856352',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360025856352',
      },
    },
  },

  ConstantContact: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/9904732168219',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/9904732168219',
      },
    },
  },

  AmazonMarketplace: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026140891',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026140891',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360026140891',
      },
    },
  },

  InternationalDutiesBilling: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/4401816013595',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/4401816013595',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/4401816013595',
      },
    },
  },

  SubScriptionPlan: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026158291',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026158291',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360026158291',
      },
    },
  },

  SendRatesStoreCheckout: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360046301731',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360046301731',
      },
    },
  },

  ThirdPartyLogisticsProvider: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/4404554170267',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/4404554170267',
      },
    },
  },

  DropshipManager: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/4414006195355',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/4414006195355',
      },
    },
  },

  MoveToNewLayout: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/4403223856155',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/4403223856155',
      },
    },
  },

  GlobalPostWalletTerms: {
    ShipStation: {
      default: 'https://www.goglobalpost.com/conditions',
    },
  },

  GlobalPostHelpArticle: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360034507571',
    },
  },

  SendleWalletTerms: {
    ShipStation: {
      default: 'https://support.sendle.com/hc/en-us/articles/205800148-Terms-and-Conditions',
      US: {
        default: 'https://support.sendle.com/hc/en-us/articles/205800148-Terms-and-Conditions',
        en: 'https://support.sendle.com/hc/en-us/articles/205800148-Terms-and-Conditions',
      },
    },
  },

  SendleDangerousGoods: {
    ShipStation: {
      default: 'https://support.sendle.com/hc/en-us/articles/205204738-What-can-t-I-Sendle-',
      US: {
        default: 'https://support.sendle.com/hc/en-us/articles/205204738-What-can-t-I-Sendle-',
        en: 'https://support.sendle.com/hc/en-us/articles/205204738-What-can-t-I-Sendle-',
      },
    },
  },

  FulfillmentProviders: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360039008232',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360039008232',
      },
    },
  },

  StoreErrorHelp: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026138071',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026138071',
      },
    },
  },

  CubiscanDimensioners: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/9974733791387',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/9974733791387',
      },
      CA: {
        en: 'https://help.shipstation.com/hc/en-ca/articles/9974733791387',
      },
    },
  },

  ShipsuranceTerms: {
    ShipStation: {
      default: 'https://www.shipstation.com/insurance-terms-and-conditions/',
    },
  },

  XCoverTerms: {
    ShipStation: {
      default: 'https://www.xcover.com/en/pds/total_shipping_protection_shipstation',
    },
  },

  XCoverInformation: {
    ShipStation: {
      default: 'https://static.xcover.com/media/pds/0b666f61-b63e-41e7-b9d7-47d80eb77432/collinson_shipment_protection_en.pdf',
    },
  },

  ParcelGuardTerms: {
    ShipStation: {
      default: 'https://www.parcelguard.com/terms/',
    },
  },

  MexicanPackageContentDescription: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/25007865974299',
    },
  },

  CarrierSharing: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/14655154520219',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/14655154520219',
      },
    },
  },

  PackingSlipSharing: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/18807930671899',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/18807930671899',
      },
      AU: {
        en: 'https://help.shipstation.com/hc/en-au/articles/18807930671899',
      },
      UK: {
        en: 'https://help.shipstation.com/hc/en-gb/articles/18807930671899',
      },
    },
  },

  FileParcelGuardClaim: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/14888782725915',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/14888782725915',
      },
      CA: {
        en: 'https://help.shipstation.com/hc/en-ca/articles/14888782725915',
      },
    },
  },

  FileXCoverClaim: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/28656549816091',
      UK: {
        default: 'https://help.shipstation.com/hc/en-gb/articles/28656549816091',
      },
      AU: {
        default: 'https://help.shipstation.com/hc/en-au/articles/28656549816091',
      },
    },
  },

  CarrierIntegrations: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/4408953242395',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/4408953242395',
      },
      CA: {
        en: 'https://help.shipstation.com/hc/en-ca/articles/4408953242395',
      },
    },
  },

  ReconfigureEtsy: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/12625903003419',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/12625903003419',
      },
    },
  },

  ReconfigureStore: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/9958070522139',
    },
  },

  ReconfigureEbay: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/12625946808219',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/12625946808219',
      },
    },
  },

  ShipStationStatus: {
    ShipStation: {
      default: 'https://status.shipstation.com/',
      US: {
        en: 'https://status.shipstation.com/',
      },
    },
  },

  YodelWalletTerms: {
    ShipStation: {
      default: 'https://www.yodeldirect.co.uk/content/about-terms',
      GB: {
        en: 'https://www.yodeldirect.co.uk/content/about-terms',
      },
    },
  },

  FedExWalletTerms: {
    ShipStation: {
      default: 'https://www.shipstation.com/fedex-merchant-agreement-for-shipstation/',
      CA: {
        en: 'https://www.shipstation.com/fedex-onebalance-canada-terms-and-conditions/',
      },
      US: {
        en: 'https://www.shipstation.com/fedex-merchant-agreement-for-shipstation/',
      },
    },
  },

  DHLExpressCAWalletTerms: {
    ShipStation: {
      default: 'https://mydhl.express.dhl/ca/en/legal/terms-and-conditions.html',
      CA: {
        'fr-CA': 'https://mydhl.express.dhl/ca/fr/legal/terms-and-conditions.html',
        default: 'https://mydhl.express.dhl/ca/en/legal/terms-and-conditions.html',
      },
    },
  },

  TaxIdentifierRequirements: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/4403172847259',
      FR: {
        default: 'https://help.shipstation.com/hc/fr-fr/articles/4403172847259',
      },
      GB: {
        default: 'https://help.shipstation.com/hc/en-gb/articles/4403172847259',
      },
      AU: {
        default: 'https://help.shipstation.com/hc/en-au/articles/4403172847259',
      },
      DE: {
        default: 'https://help.shipstation.com/hc/de/articles/4403172847259',
      },
    },
  },

  StampsDHLExpressTerms: {
    ShipStation: {
      default: 'https://mydhl.express.dhl/us/en/legal/terms-and-conditions.html',
    },
  },

  EVRiWalletTerms: {
    ShipStation: {
      default: 'https://www.evri.com/terms-and-conditions',
      GB: {
        en: 'https://www.evri.com/terms-and-conditions',
      },
    },
  },

  ParcelforceWalletTerms: {
    ShipStation: {
      default: 'https://www.parcelforce.com/terms-and-conditions',
      GB: {
        en: 'https://www.parcelforce.com/terms-and-conditions',
      },
    },
  },

  DpdWalletTerms: {
    ShipStation: {
      default: 'https://www.dpd.co.uk/standard_terms_and_conditions.jsp',
      GB: {
        en: 'https://www.dpd.co.uk/standard_terms_and_conditions.jsp',
      },
    },
  },

  BrtItWalletTerms: {
    ShipStation: {
      default: 'https://www.brt.it/en/terms-and-conditions-of-use/',
      IT: {
        en: 'https://www.brt.it/en/terms-and-conditions-of-use/',
      },
    },
  },

  CorreosExpressWalletTerms: {
    ShipStation: {
      default: 'https://www.correosexpress.com/web/correosexpress/terminosycondicionesdetransporte',
      ES: {
        en: 'https://www.correosexpress.com/web/correosexpress/terminosycondicionesdetransporte',
      },
      PT: {
        en: 'https://www.correosexpress.com/web/correosexpress/terminosycondicionesdetransporte',
      },
    },
  },

  ODBCOverview: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026142131',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026142131',
      },
    },
  },

  AutoSplitOverview: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/17465241673627',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/17465241673627',
      },
    },
  },

  ProductBundlesOverview: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/17398370106779',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/17398370106779',
      },
    },
  },

  ShippingStrategiesOverview: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/4415714484123',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/4415714484123',
      },
    },
  },

  DHLEcommerceTerms: {
    ShipStation: {
      default: 'https://www.dhl.com/us-en/home/ecommerce-solutions/business-help-center/platform-shippers-terms-and-conditions.html',
      US: {
        en: 'https://www.dhl.com/us-en/home/ecommerce-solutions/business-help-center/platform-shippers-terms-and-conditions.html',
      },
    },
  },

  EditStoreSettings: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360036323551',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360036323551',
      },
    },
  },

  DHLEcommerceDDPTerms: {
    ShipStation: {
      default:
        'https://www.dhl.com/content/dam/dhl/global/dhl-ecommerce/documents/pdf/terms-and-conditions-duty-and-tax-ecommerce-solutions-new.pdf',
      US: {
        en: 'https://www.dhl.com/content/dam/dhl/global/dhl-ecommerce/documents/pdf/terms-and-conditions-duty-and-tax-ecommerce-solutions-new.pdf',
      },
    },
  },

  DelegateOrdersFulfillmentProviders: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/4404554172699',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/4404554172699',
      },
    },
  },

  ReturnRabbit: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/18824060240795',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/18824060240795',
      },
    },
  },

  SendleCAWalletTerms: {
    ShipStation: {
      default: 'https://support.sendle.com/hc/en-ca/articles/205800148-Terms-and-Conditions',
      CA: {
        en: 'https://support.sendle.com/hc/en-ca/articles/205800148-Terms-and-Conditions',
      },
    },
  },

  SendleCAWalletDangerousGoods: {
    ShipStation: {
      default: 'https://support.sendle.com/hc/en-ca/articles/205204738-What-can-t-I-Sendle-',
      CA: {
        en: 'https://support.sendle.com/hc/en-ca/articles/205204738-What-can-t-I-Sendle-',
      },
    },
  },

  ShipStationCarriers: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026142091',
      CA: {
        default: 'https://help.shipstation.com/hc/en-ca/articles/360026142091',
      },
      AU: {
        default: 'https://help.shipstation.com/hc/en-au/articles/360026142091',
      },
      GB: {
        default: 'https://help.shipstation.com/hc/en-gb/articles/360026142091',
      },
      FR: {
        default: 'https://help.shipstation.com/hc/fr-fr/articles/360026142091',
      },
      DE: {
        default: 'https://help.shipstation.com/hc/de/articles/360026142091',
      },
    },
  },

  ConnectBYOA: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025869732',
      CA: {
        default: 'https://help.shipstation.com/hc/en-ca/articles/360025869732',
      },
      AU: {
        default: 'https://help.shipstation.com/hc/en-au/articles/360025869732',
      },
      GB: {
        default: 'https://help.shipstation.com/hc/en-gb/articles/360025869732',
      },
      FR: {
        default: 'https://help.shipstation.com/hc/fr-fr/articles/360025869732',
      },
      DE: {
        default: 'https://help.shipstation.com/hc/de/articles/360025869732',
      },
    },
  },

  SplitShip: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360028798951',
      FR: {
        default: 'https://help.shipstation.com/hc/fr-fr/articles/360028798951',
      },
      CA: {
        default: 'https://help.shipstation.com/hc/en-ca/articles/360028798951',
      },
      GB: {
        default: 'https://help.shipstation.com/hc/en-gb/articles/360028798951',
      },
      AU: {
        default: 'https://help.shipstation.com/hc/en-au/articles/360028798951',
      },
      DE: {
        default: 'https://help.shipstation.com/hc/de/articles/360028798951',
      },
    },
  },

  CustomerSupport: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025853032',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025853032',
      },
    },
  },

  [linkIDs.SenderEmails]: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/23751516679323-Email-Domain-Authentication-DMARC',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/23751516679323-Email-Domain-Authentication-DMARC',
      },
    },
  },

  CommonLabelRateErrors: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/19748165115547',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/19748165115547',
      },
    },
  },

  InventorySync: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/25902328295323',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/25902328295323',
      },
    },
  },

  InventorySyncTargetsFAQ: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/28449272626075-Inventory-Sync-FAQ',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/28449272626075-Inventory-Sync-FAQ',
      },
    },
  },

  FinaleInventory: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025856372-Finale-Inventory',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025856372-Finale-Inventory',
      },
    },
  },

  FishbowlInventory: {
    ShipStation: {
      default: 'https://help.fishbowlinventory.com/advanced/s/article/ShipStation',
      US: {
        en: 'https://help.fishbowlinventory.com/advanced/s/article/ShipStation',
      },
    },
  },

  CIN7Inventory: {
    ShipStation: {
      default:
        'https://help.shipstation.com/hc/en-us/articles/360025855392-Cin7-Core#UUID-1c49ef68-68f1-d8f5-62b5-fe11ce59a677_UUID-ab2ba6e7-f7df-9bca-a850-3ceb2d56a3ba',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025855392-Cin7-Core#UUID-1c49ef68-68f1-d8f5-62b5-fe11ce59a677_UUID-ab2ba6e7-f7df-9bca-a850-3ceb2d56a3ba',
      },
    },
  },

  SkuVaultInventory: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025856452-SkuVault',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025856452-SkuVault',
      },
    },
  },

  EcomDashInventory: {
    ShipStation: {
      default: 'https://support.ecomdash.com/hc/en-us/articles/210221583-How-do-I-connect-ecomdash-with-ShipStation',
      US: {
        en: 'https://support.ecomdash.com/hc/en-us/articles/210221583-How-do-I-connect-ecomdash-with-ShipStation',
      },
    },
  },

  ZenventoryInventory: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025856512-Zenventory',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025856512-Zenventory',
      },
    },
  },

  CreatePrintYourFirstLabel: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026156831',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026156831',
      },
    },
  },

  CompareRates: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026157611',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026157611',
      },
    },
  },

  WhatIsBranding: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025870252',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025870252',
      },
    },
  },

  CreateCustomEmailTemplates: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360037571571',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360037571571',
      },
    },
  },

  ImportOrdersFromAStore: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026156891',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026156891',
      },
    },
  },

  CreateAutomationRules: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026158331',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026158331',
      },
    },
  },

  AutomationRuleExamples: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360029962911',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360029962911',
      },
    },
  },

  BrandedTrackingPage: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026158351',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026158351',
      },
    },
  },

  ReturnLabels: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026157771',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026157771',
      },
    },
  },

  AddInsuranceToShipments: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026157711',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026157711',
      },
    },
  },

  AddressValidation: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025869092',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025869092',
      },
    },
  },

  CreateCustomPackage: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026158451',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026158451',
      },
    },
  },

  ShipInternationally: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360047475651',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360047475651',
      },
    },
  },

  InternationalSettings: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360035991611',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360035991611',
      },
    },
  },

  CustomizePackingSlips: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360057378051',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360057378051',
      },
    },
  },

  TagOrders: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026156931',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026156931',
      },
    },
  },

  OutgoingReturns: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026157771',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026157791',
      },
    },
  },

  BrandedReturnsPortal: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026158371',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026158371',
      },
    },
  },

  SelectLabelLayout: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025869852',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025869852',
      },
    },
  },

  CreateShippingPresets: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360036323651',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360036323651',
      },
    },
  },

  BarcodePresets: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360036323651',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360036323651',
      },
    },
  },

  PrintingWithConnect: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026157851',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026157851',
      },
    },
  },

  ShopifyInventory: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360036812011',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026158191',
      },
    },
  },

  InsightsReports: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360026158191',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026158191',
      },
    },
  },

  CommunityIdeas: {
    ShipStation: {
      default: 'https://community.shipstation.com/t5/Ideas/ct-p/Ideas',
      US: {
        en: 'https://community.shipstation.com/t5/Ideas/ct-p/Ideas',
      },
    },
  },

  GoogleShippingData: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/4404308179867-Google-Shipping-Data',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/4404308179867-Google-Shipping-Data',
      },
    },
  },

  [linkIDs.InventoryInShipstation]: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025870392',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025870392',
      },
    },
  },

  [linkIDs.ShippingStrategiesHelp]: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/4415714484123',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/4415714484123',
      },
    },
  },

  WindsorFrameworkDetails: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/28543998416155',
      GB: {
        default: 'https://help.shipstation.com/hc/en-gb/articles/28543998416155',
      },
    },
  },

  [linkIDs.RateShopperHelp]: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/4415714484123',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/4415714484123',
      },
    },
  },

  ShipstationApiDocs: {
    ShipStation: {
      default: 'https://www.shipstation.com/docs/api/',
      US: {
        en: 'https://www.shipstation.com/docs/api/',
      },
    },
  },

  ShipstationV2ApiDocs: {
    ShipStation: {
      default: 'https://docs.shipstation.com',
      US: {
        en: 'https://docs.shipstation.com',
      },
    },
  },

  AdaptiveMfaInfo: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/30776076492699-Adaptive-Multi-Factor-Authentication',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/30776076492699-Adaptive-Multi-Factor-Authentication',
      },
    },
  },

  AustraliaPostMyPostBusinessWalletTerms: {
    ShipStation: {
      default: 'https://auspost.com.au/content/dam/auspost_corp/media/documents/australia-post-general-terms-and-conditions.pdf',
      AU: {
        en: 'https://auspost.com.au/content/dam/auspost_corp/media/documents/australia-post-general-terms-and-conditions.pdf',
      },
    },
  },

  AustraliaPostMyPostBusinessWalletEcommercePartnerResellerTerms: {
    ShipStation: {
      default:
        'https://auspost.com.au/content/dam/auspost_corp/media/documents/australia-post-ecommerce-partner-reseller-delivery-service-terms-and-conditions.pdf',
      AU: {
        en: 'https://auspost.com.au/content/dam/auspost_corp/media/documents/australia-post-ecommerce-partner-reseller-delivery-service-terms-and-conditions.pdf',
      },
    },
  },

  [linkIDs.WhyIsTaxIDRequired]: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/29009051990555',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/29009051990555',
      },
    },
  },

  AramexAUWalletConditionsOfCarriage: {
    ShipStation: {
      default: 'https://www.aramex.com.au/terms-and-conditions/conditions-of-carriage/',
      AU: {
        en: 'https://www.aramex.com.au/terms-and-conditions/conditions-of-carriage/',
      },
    },
  },

  RoyalMailClickAndDropWalletTerms: {
    ShipStation: {
      default: 'https://www.royalmail.com/terms-and-conditions',
      GB: {
        en: 'https://www.royalmail.com/terms-and-conditions',
      },
    },
  },

  DHLExpressMyDHLWalletTerms: {
    ShipStation: {
      default: 'https://mydhl.express.dhl/us/en/legal.html',
      US: {
        en: 'https://mydhl.express.dhl/us/en/legal.html',
      },
    },
  },

  AmazonShippingWalletTerms: {
    ShipStation: {
      default: 'https://shipping.amazon.com/shipping-terms-and-conditions',
      US: {
        en: 'https://shipping.amazon.com/shipping-terms-and-conditions',
      },
    },
  },

  [linkIDs.RefundAssist]: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/40934965578139-Refund-Assist',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/40934965578139-Refund-Assist',
      },
    },
  },

  [linkIDs.EnhancedReturns]: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/38629467096091-ShipStation-s-Returns-Exchanges-for-Shopify-Management',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/38629467096091-ShipStation-s-Returns-Exchanges-for-Shopify-Management',
      },
    },
  },

  AmazonShippingPickup: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/40691569416859',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/40691569416859',
      },
    },
  },

  ParcelforceRoyalMailClickAndDropWalletTerms: {
    ShipStation: {
      default: 'https://www.royalmail.com/terms-and-conditions',
      GB: {
        en: 'https://www.royalmail.com/terms-and-conditions',
      },
    },
  },

  [linkIDs.ProductSyncLearnMore]: {
    ShipStation: {
      default:
        'https://help.shipstation.com/hc/en-us/articles/360026158091-Add-Product-Records#UUID-b5f2bab1-5bc1-0d7b-f278-9d22c216c766_UUID-c0ea255a-3a52-35a3-18eb-06b8d6cbb601',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360026158091-Add-Product-Records#UUID-b5f2bab1-5bc1-0d7b-f278-9d22c216c766_UUID-c0ea255a-3a52-35a3-18eb-06b8d6cbb601',
      },
    },
  },

  [linkIDs.ShopifyMetafieldsLearnMore]: {
    ShipStation: {
      default: 'https://help.shopify.com/en/manual/custom-data/metafields#how-to-use-metafields',
    },
  },

  [linkIDs.UserRoles]: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025870172',
      US: {
        default: 'https://help.shipstation.com/hc/en-us/articles/360025870172',
        en: 'https://help.shipstation.com/hc/en-us/articles/360025870172',
        es: 'https://help.shipstation.com/hc/es-us/articles/360025870172',
      },
      CA: {
        fr: 'https://help.shipstation.com/hc/fr-fr/articles/360025870172',
      },
      FR: {
        fr: 'https://help.shipstation.com/hc/fr-fr/articles/360025870172',
      },
      DE: {
        de: 'https://help.shipstation.com/hc/de/articles/360025870172',
      },
    },
  },
  [linkIDs.CustomsUpdates]: {
    ShipStation: {
      default: 'https://help.shipstation.com/hc/en-us/articles/360025869952-Customs-Declarations',
      US: {
        en: 'https://help.shipstation.com/hc/en-us/articles/360025869952-Customs-Declarations',
      },
    },
  },
};
